import store from '@/store';

// const bmapAK = 'xm6vjlrjrWHnc3C3r5xw6IR3Tc4zcGsl';
// const bmapAK = 'h1pzKP8GXqH2TV0kcXbGRuSHYs6iialF';
// const bmapAK = '8PVe3lyuShOPRqLAIT3MAlopPGcMBhIs';
const bmapAK = 'ScvLWGTKMB6VsgeQTx0UJTnyZ34qPdOY';

function asyncScript(url, obj) {
  return new Promise((resolve, reject) => {
    if (window[obj]) {
      resolve();
      return;
    }
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = 'async';
    if (/callback=onMapCallback/.test(url)) {
      window.onMapCallback = function () {
        resolve();
      };
    } else {
      script.onload = () => {
        resolve();
      };
    }
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export function loadAMap() {
  return asyncScript(
    'https://webapi.amap.com/maps?v=1.4.15&key=b97ccba95daa66d0406028b2cb10ede0',
    'AMap'
  );
}

export function loadAMapUI() {
  return asyncScript('https://webapi.amap.com/ui/1.1/main.js', 'AMapUI');
}

export function loadBMap(version = '3.0', type, symbol = 'BMap') {
  // 获取在线
  if (store.state.admin.profile.mapTile) {
    window.bmapcfg = {
      imgext: '.png',
      tiles_dir: store.state.admin.profile.mapTile
    };
    const scripts = document.getElementsByTagName('script');
    const JS__FILE__ = scripts[scripts.length - 1].getAttribute('src');
    window.bmapcfg.home = JS__FILE__.substr(0, JS__FILE__.lastIndexOf('/') + 1);
    return asyncScript('static/map/js/bmap_offline_api_min.js', 'BMap');
  } else {
    const t = type ? `&type=${type}` : '';
    return asyncScript(
      // `https://api.map.baidu.com/api?v=${version}${t}&ak=EXALavXDQ9ak2Pt7ltHngDcdr9AMG0mB&callback=onMapCallback`,
      `https://api.map.baidu.com/api?v=${version}${t}&ak=${bmapAK}&callback=onMapCallback`,
      symbol
    );
  }
}

export function loadBMapV3(version = '3.0', type, symbol = 'BMap') {
  // 获取在线
  if (store.state.admin.profile.mapTile) {
    const urls = [
      ['/static/bmap-offline/map3.0_init.js', 'map3.0_init_loaded'],
      ['/static/bmap-offline/map3.0.js?callback=onMapCallback', 'BMap']
    ];

    return new Promise((resolve, reject) => {
      asyncScript(...urls[0])
        .then(() => {
          asyncScript(...urls[1])
            .then(resolve)
            .catch(reject);
        })
        .catch(reject);
    });
  } else {
    const t = type ? `&type=${type}` : '';
    return asyncScript(
      // `https://api.map.baidu.com/api?v=${version}${t}&ak=EXALavXDQ9ak2Pt7ltHngDcdr9AMG0mB&callback=onMapCallback`,
      `https://api.map.baidu.com/api?v=${version}${t}&ak=${bmapAK}&callback=onMapCallback`,
      symbol
    );
  }
}

export function loadBMapHeat() {
  return asyncScript('static/map/js/Heatmap_min.js', 'BMapLib');
}

export function loadMapLibreGL() {
  return asyncScript('/static/js/maplibre-gl.js', 'maplibregl');
}
